import { writable, get, derived } from "svelte/store";

import { location, querystring, push, pop } from "svelte-spa-router";

import hash, { writeToStream } from "object-hash";

import clone from "just-clone";

import { toggleAlertAudio } from "./audio-service.js";

import Detector from 'detector-js';

const detector = new Detector(window.navigator.userAgent);

export const OS = writable(detector.os.name);

export const forwardToApp = writable([
  "Android",
  // "iOS",
])

export const isWebOnMobile = derived(OS, $OS => {
  return ($OS == "Android" || $OS == "iOS") && !window.cordova;
});

export const business = writable(null);
export const loyaltyRules = writable([]);

export const showSectionsSlider = writable(true);

export const toastMsg = writable(null);

export const menuDraft = writable(null);
export const specialsDraft = writable(null);

export const popup = writable({ show: false, msg: "" });

export const acceptedCookies = writable(
  JSON.parse(localStorage.getItem("acceptedCookies"))
);

let c = localStorage.getItem("cart");

export const cart = writable(
  c
    ? JSON.parse(c)
    : {
      details: {},
      items: {},
    }
);

let lv = localStorage.getItem("lastVisits");

export const lastVisits = writable(lv ? JSON.parse(lv) : { "BUTK": { "ts": 1639387834412, "title": "בוטקה" }, "PAAMAIM": { "ts": 1639387881314, "title": "פעמיים קפה" }, "EREZ": { "ts": 1639387890948, "title": "לחם ארז - שינקין" } });

export const user = writable(null);

export const userDetails = writable(null);

// export const adminOrders = writable([]);

export const myOrder = writable("loading");

export const navSearchQuery = writable("");

export const orderOnLogin = writable(false);

export const loading = writable(false);

export const showSplash = writable(false);

export const isAdmin = writable("loading");

export const orders = writable(null) //all admin orders

export const scrollY = writable(0);

export const fcmToken = writable();

export const openOrders = derived(orders, $orders => {
  if (!$orders) return [];
  let open = $orders.filter(order => order.open);
  open.sort((a, b) => a.createdAt.seconds - b.createdAt.seconds);
  return open;
})

export const closedOrders = derived(orders, $orders => {
  if (!$orders) return [];
  let closed = $orders.filter(order => !order.open)
  closed.sort((a, b) => b.createdAt.seconds - a.createdAt.seconds)
  return closed
})

export const categoryFilters = writable(
  JSON.parse(localStorage.getItem("categoryFilters")) || []
); //admin orders filters

categoryFilters.subscribe(cf => {
  localStorage.setItem("categoryFilters", JSON.stringify(cf));
})

export const ordersFilteredByCategory = derived([openOrders, categoryFilters], ([$openOrders, $categoryFilters]) => {
  let filtered = $openOrders.filter(order => {
    if ($categoryFilters.length == 0) return true;
    if (!order.categories || order.categories.length == 0) return false;

    let isVisible = false;
    order.categories.forEach((cat) => {
      if ($categoryFilters.includes(cat)) {
        isVisible = true;
        return;
      }
    });
    return isVisible;
  })
  return filtered;
}) //all admin orders

export const newOrdersCount = derived(ordersFilteredByCategory, $ordersFilteredByCategory => {
  return $ordersFilteredByCategory.filter(order => {
    return order.alert ? order.alert.on : false;
  }).length;
})

newOrdersCount.subscribe(count => {
  toggleAlertAudio(count > 0);
});

export var pageClicked = writable(false);

export function saveCart() {
  localStorage.setItem("cart", JSON.stringify(get(cart)));
}

export function clearState() {
  localStorage.clear();
}

export function clearCart() {
  cart.set({
    details: {},
    items: {},
  });
  saveCart();
  console.log("cart cleared");
}

export function removeFromCart({ hash }) {
  cart.update((c) => {
    if (c.items[hash].count > 1) {
      c.items[hash].count -= 1;
    } else {
      delete c.items[hash];
    }
    if (Object.keys(c.items).length == 0) {
      c.details = {};
      c.item = {};
      pop();
    }
    return c;
  });

  saveCart();
}

export function addToCart(item, section, options, checkboxes, price) {
  let b = get(business);
  let c = get(cart);

  if (c?.details?.code != b.code) {
    //reset cart if new order is from a different business
    c = {
      items: {},
      details: {
        code: b.code,
        title: b.title,
        notes: "",
      },
    };
  }
  let o = {
    name: item.name,
    id: item.id,
    options: clone(options),
    checkboxes: clone(checkboxes),
    price,
    section,
    category: item.category
  };

  let itemHash = hash(o);

  if (c.items[itemHash]) {
    c.items[itemHash].count += 1;
  } else {
    //new item in cart
    o.count = 1;
    o.hash = itemHash;
    c.items[itemHash] = o;
  }
  cart.set(c);

  saveCart();
}

export function showPopup(msg, callback) {
  popup.set({
    msg,
    callback,
  });

  let loc = get(location);
  let qs = get(querystring);
  if (qs.search("showPopup=true") == -1) {
    push(loc + qs + "?showPopup=true");
  }
}

function saveLastVisits() {
  localStorage.setItem("lastVisits", JSON.stringify(get(lastVisits)));
}

export function addVisit(business) {
  lastVisits.update((lv) => {
    lv[business.code] = {
      ts: Date.now(),
      title: business.title,
    };
    return lv;
  });
  saveLastVisits();
}
